(() => {
  const widget = document.querySelector('.rumi-wa');
  if (!widget) return;
  const invite = widget.querySelector('.rumi-wa__invite');
  const key = 'rumi-whatsapp-visit';
  let visit = { startedAt: Date.now(), shown: false };
  let timer;

  const readVisit = () => {
    try {
      const saved = JSON.parse(sessionStorage.getItem(key));
      if (saved && Number.isFinite(saved.startedAt) && typeof saved.shown === 'boolean') visit = saved;
    } catch (_) {}
  };
  const saveVisit = () => {
    try { sessionStorage.setItem(key, JSON.stringify(visit)); } catch (_) {}
  };
  readVisit();
  saveVisit();

  const dismiss = () => {
    clearTimeout(timer);
    visit.shown = true;
    saveVisit();
    invite.hidden = true;
  };
  widget.querySelector('.rumi-wa__close').addEventListener('click', dismiss);
  widget.querySelectorAll('a').forEach(link => link.addEventListener('click', dismiss));
  widget.addEventListener('keydown', event => {
    if (event.key === 'Escape' && !invite.hidden) {
      const restoreFocus = invite.contains(document.activeElement);
      dismiss();
      if (restoreFocus) widget.querySelector('.rumi-wa__logo').focus();
    }
  });
  const hide = () => {
    // Avoid removing an invitation while a keyboard user is interacting with it.
    if (invite.contains(document.activeElement)) {
      timer = setTimeout(hide, 1000);
      return;
    }
    invite.hidden = true;
  };
  const show = () => {
    readVisit();
    if (visit.shown) return;
    if (document.hidden) {
      timer = setTimeout(show, 2000);
      return;
    }
    // Record the impression immediately so navigation never repeats the card.
    visit.shown = true;
    saveVisit();
    invite.hidden = false;
    timer = setTimeout(hide, 8000);
  };
  const revealOnRequest = () => {
    if (!invite.hidden) return;
    clearTimeout(timer);
    visit.shown = true;
    saveVisit();
    invite.hidden = false;
    timer = setTimeout(hide, 8000);
  };
  const logo = widget.querySelector('.rumi-wa__logo');
  logo.addEventListener('pointerenter', event => {
    if (event.pointerType === 'mouse' && window.matchMedia('(hover: hover)').matches) revealOnRequest();
  });
  logo.addEventListener('focus', revealOnRequest);
  const schedule = () => {
    clearTimeout(timer);
    readVisit();
    invite.hidden = true;
    if (!visit.shown) timer = setTimeout(show, Math.max(0, 12000 - (Date.now() - visit.startedAt)));
  };
  window.addEventListener('pagehide', () => clearTimeout(timer));
  window.addEventListener('pageshow', event => { if (event.persisted) schedule(); });
  schedule();
})();
